module.exports = __webpack_public_path__ + "static/etude-01-s.97cb5fab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/etude/etude-01-s.jpg
// module id = 89
// module chunks = 75978498060966 88197199937824 213720915766396